<template>
  <v-container fluid>
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="filteredAllEmployee"
      @onSearch="viewState.state.filters.searchText = $event"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      @removeAllFilters="viewState.state.filters.values = []"
      :emptyObjectData="emptyObjectData"
    >
    </UniversalTable>
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee Readiness"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="[]"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
  </v-container>
</template>

<script setup>
import { computed, defineProps } from "vue";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "./composables/useTableConfig";
import { useEmployeeDirectoryViewState } from "./composables/useViewState";
import SearchModal from "@components/SearchBar/SearchModal.vue";

const tableConfig = useTableConfig();
const viewState = useEmployeeDirectoryViewState();
const emptyObjectData = {
  singular: "Employee",
  plural: "Employees",
};
const props = defineProps({
  dataSource: {
    type: Array,
    default: () => [],
  },
});

const filteredAllEmployee = computed(() => {
  let allEmployee = props?.dataSource;
  // Filter by current_status to only show active employees
  allEmployee = allEmployee.filter((el) => el.current_status === "active");

  if (
    viewState.state.filters.searchText &&
    viewState.state.filters.searchText.length > 0
  ) {
    const searchText = viewState.state.filters.searchText.toLowerCase();

    allEmployee = allEmployee.filter((el) => {
      const fullName = `${el.first_name} ${el.last_name}`.toLowerCase();
      return (
        fullName.includes(searchText) ||
        el.first_name.toLowerCase().includes(searchText)
      );
    });
  }
  return allEmployee;
});
</script>

<style scoped>
.icon-container {
  cursor: pointer;
}
</style>
